<template>
  <div class="flex justify-center">
    <AppLink
      v-for="(item, index) in badgeIcons"
      :key="index"
      :to="item.link"
      class="mx-1.5 md:mx-5"
      @click.native="sendGaEvent('丸アイコン', item.link, item.title)"
    >
      <div class="size-74px md:size-100px mx-auto flex items-center justify-center rounded-full bg-Black04">
        <AppIcon :icon="item.icon" class="w-50px md:w-60px" />
      </div>
      <p class="mt-2 text-center text-xs md:mt-3 md:text-base">{{ item.title }}</p>
    </AppLink>
  </div>
</template>

<script>
import { defineComponent, useContext } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { PRODUCT_PARAM_QUERIES } from '~/constants';
import { url } from '~/utils';
import { sendGaEvent } from '~/utils/ga';
import { BooleanLike } from '~/enums';

export default defineComponent({
  components: {
    AppIcon,
    AppLink,
  },
  setup() {
    const { i18n } = useContext();

    const badgeIcons = [
      {
        title: i18n.t('TOP-01.badgeIcons.newWine').toString(),
        link: {
          path: url('ITEM_LIST'),
          query: {
            [PRODUCT_PARAM_QUERIES.NEW]: BooleanLike.TRUE,
            [PRODUCT_PARAM_QUERIES.QTY]: BooleanLike.TRUE,
          },
        },
        icon: 'NewWine',
      },
      {
        title: i18n.t('TOP-01.badgeIcons.freeShipping').toString(),
        link: {
          path: url('ARCHIVES_FREE_SHIPPING'),
        },
        icon: 'FreeShipping',
      },
      {
        title: i18n.t('TOP-01.badgeIcons.sale').toString(),
        link: {
          path: url('ITEM_LIST'),
          query: {
            [PRODUCT_PARAM_QUERIES.TAG]: 'セール',
            [PRODUCT_PARAM_QUERIES.QTY]: BooleanLike.TRUE,
          },
        },
        icon: 'Sale',
      },
      {
        title: i18n.t('TOP-01.badgeIcons.ranking').toString(),
        link: url('RANKING'),
        icon: 'Ranking',
      },
    ];

    return { badgeIcons, sendGaEvent };
  },
});
</script>

<style scoped>
.size-100px {
  width: 100px;
  height: 100px;
}
.size-74px {
  width: 74px;
  height: 74px;
}
.w-50px {
  width: 50px;
}
.w-60px {
  width: 60px;
}
</style>
